import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class BannerImage {
  constructor(section) {
    this.container = section.container;

    this.init();
  }

  init() {
    this.handleImageAnimation(true);
  }

  /**
   * Handles image animation that would be triggered on page load
   *  - uses a fallback class modifier for Banner image section with no cached hero images
   *  - that class resets the default banner CSS animation so it won't be executed when `.img-in` class is added when `img.complete` is detected
   *  - gets the `.lazy-image` container and listens for `transitionend` event of its `<img>` child element
   *  - adds a class modifier after `<img>` transition has completed, when shimmer effect has been removed, that should trigger the hero image animation
   *  - removes classes on Theme Editor `shopify:section:unload` and `shopify:section:reorder` events
   */
  handleImageAnimation(onLoad = false) {
    if (!onLoad) {
      this.container.classList.remove(c.classes$o.bannerNoCachedImages);
      this.container.classList.remove(c.classes$o.bannerImgLoaded);
      return;
    }

    const imageWrapper = this.container.querySelector(s.selectors$w.imageWrapper);
    const img = imageWrapper.querySelectorAll(s.selectors$w.lazyImage);
    const imgComplete = this.container.classList.contains(c.classes$o.imgIn);

    if (img.length && !imgComplete) {
      this.container.classList.add(c.classes$o.bannerNoCachedImages);

      const onImageTransitionEnd = (event) => {
        requestAnimationFrame(() => this.container.classList.add(c.classes$o.bannerImgLoaded));
        img[0].removeEventListener('transitionend', onImageTransitionEnd);
      };

      img[0].addEventListener('transitionend', onImageTransitionEnd);
    }
  }

  onReorder() {
    this.handleImageAnimation(false);
  }

  onUnload() {
    this.handleImageAnimation(false);
  }
}